module.exports = __webpack_public_path__ + "img/look_system_pic.13899f78.png";